import { useMemo } from 'react'
import { useAnchorWallet, useConnection } from '@solana/wallet-adapter-react'

import { TradeProvider } from '../lib/tradeProvider'

const useTradeProvider = () => {
  const anchorWallet = useAnchorWallet()
  const { connection } = useConnection()

  return useMemo(
    () => anchorWallet && new TradeProvider(connection, anchorWallet),
    [anchorWallet, connection]
  )
}

export default useTradeProvider
